import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const multiCloudProvisionerFrontendPlugin = createPlugin({
  id: 'multi-cloud-provisioner-frontend',
  routes: {
    root: rootRouteRef,
  },
});

export const MultiCloudProvisionerFrontendPage = multiCloudProvisionerFrontendPlugin.provide(
  createRoutableExtension({
    name: 'MultiCloudProvisionerFrontendPage',
    component: () =>
      import('./components/ProjectPageComponent').then(m => m.ProjectPageComponent),
    mountPoint: rootRouteRef,
  }),
);
